import * as React from "react";

interface IGoalStates {

}

interface IGoalProps {
    text: string;
}

export default class Goal extends React.Component<IGoalProps, IGoalStates> {
    constructor(props: IGoalProps) {
        super(props);
    }

    public render() {
        return (
            <div className="goal">
                <p dangerouslySetInnerHTML={{__html: this.props.text}} />
            </div>
        );
    }
}
